import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import LoadTrigger from 'src/components/LoadTrigger';
import RecommendationBucket from 'src/components/RecommendationBucket';
import {RecommendationsService, TARGET_ME_KEY} from 'src/services/RecommendationsService';
import {LoadState} from 'src/types/enums';
import {LoadingRecommendationRow} from 'src/components/CollegeSearch/LoadingRecommendation';
import 'stylesheets/components/college-search/college-search-buckets.scss';

class Buckets extends React.Component {
  static propTypes = {
    recommendationsShownEventId: PropTypes.string,
    buckets: PropTypes.array.isRequired,
    getBuckets: PropTypes.func.isRequired,
    followCollege: PropTypes.func.isRequired,
    getRecommendationBucketColleges: PropTypes.func.isRequired,
    unfollowCollege: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    collegeApplicationStatuses: PropTypes.object.isRequired,
    targetMeBucket: PropTypes.object,
    setCollegeAppStatus: PropTypes.func.isRequired,
  };

  componentDidMount() {
    RecommendationsService.getRecommendationBucketCount().then((limit) =>
      this.props.getBuckets(limit)
    );
  }

  loadBucket = (bucket) => {
    bucket &&
      this.props.getRecommendationBucketColleges({
        bucketId: bucket.id,
        bucketIndex: bucket.index,
        totalBucketCount: this.props.buckets.length,
        recommendationsShownEventId: this.props.recommendationsShownEventId,
      });
  };

  isLoading = () =>
    Boolean(this.props.buckets.find((bucket) => bucket.loadState === LoadState.LOADING));

  getUnloadedBucketIndex = () =>
    this.props.buckets.findIndex((bucket) => bucket.loadState === LoadState.NONE);

  loadNextBucket = () => {
    const startingIndex = this.getUnloadedBucketIndex();
    this.props.buckets.slice(startingIndex, startingIndex + 3).forEach(this.loadBucket);
  };

  hasUnloadedBuckets = () => this.getUnloadedBucketIndex() > -1;

  render() {
    const props = this.props;
    const targetMeBucket = props.targetMeBucket || {};
    const isSenior = (props.user.highSchoolInfo || {}).senior;

    return (
      <section className={classnames('college-search-buckets')}>
        {targetMeBucket.loadState === LoadState.LOADED && (
          <RecommendationBucket
            key={targetMeBucket.id}
            recommendationBucket={targetMeBucket}
            isSenior={isSenior}
            collegeApplicationStatuses={props.collegeApplicationStatuses}
            recommendationsShownId={props.recommendationsShownEventId}
            setCollegeAppStatus={props.setCollegeAppStatus}
            followCollege={props.followCollege}
            unfollowCollege={props.unfollowCollege}
          />
        )}
        {props.buckets.map((bucket) => {
          if (bucket.id === TARGET_ME_KEY) return null;

          if (bucket.loadState === LoadState.LOADING) {
            return <LoadingRecommendationRow rowCount={1} key={bucket.id} />;
          }

          if (bucket.loadState === LoadState.LOADED) {
            return (
              <RecommendationBucket
                key={bucket.id}
                recommendationBucket={bucket}
                isSenior={isSenior}
                collegeApplicationStatuses={props.collegeApplicationStatuses}
                recommendationsShownId={props.recommendationsShownEventId}
                setCollegeAppStatus={props.setCollegeAppStatus}
                followCollege={props.followCollege}
                unfollowCollege={props.unfollowCollege}
              />
            );
          }
        })}
        <LoadTrigger
          hasMore={this.hasUnloadedBuckets()}
          onLoadMore={this.loadNextBucket}
          isLoading={this.isLoading()}
        />
      </section>
    );
  }
}

export default Buckets;
